import { render, staticRenderFns } from "./step2.vue?vue&type=template&id=398b694d&scoped=true&"
import script from "./step2.vue?vue&type=script&lang=js&"
export * from "./step2.vue?vue&type=script&lang=js&"
import style0 from "./step2.vue?vue&type=style&index=0&id=398b694d&lang=less&scoped=true&"
import style1 from "./step2.vue?vue&type=style&index=1&id=398b694d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b694d",
  null
  
)

export default component.exports